/**
 * World z-order (zIndex on the camera container's children).
 * Enemy bullets sit ABOVE player effects: they are the information the player
 * must read; they always win overdraw.
 */
export const Layer = {
  Floor: 0,
  Telegraphs: 10,
  PlayerFx: 20,
  Pickups: 30,
  Entities: 40,
  EnemyBullets: 50,
  Fx: 60,
} as const;
